import { useEffect, useState } from "react";
import { CheckCircle2, Mail } from "lucide-react";
import { api, timeAgo } from "@/lib/api";

export function ContactInbox() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/contact-messages").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const done = (id) => api.post(`/admin/contact-messages/${id}/done`).then(load);
  if (items === null) return <p className="text-slate-400">Loading…</p>;
  if (!items.length) return <div data-testid="admin-contact-empty" className="rounded-2xl border border-dashed border-white/15 p-10 text-center text-slate-400">No contact messages yet.</div>;
  return (
    <div className="space-y-3">
      {items.map((m) => (
        <div key={m.id} data-testid={`admin-contact-${m.id}`} className={`rounded-2xl bg-[#173742] p-5 ${m.status === "done" ? "opacity-60" : ""}`}>
          <div className="flex flex-wrap items-center gap-2">
            <p className="font-display font-bold">{m.subject}</p>
            {m.status === "new" && <span className="rounded-full bg-[#d4f253] px-2 py-0.5 text-[10px] font-bold uppercase text-[#0f2a33]">new</span>}
            <span className="ml-auto text-xs text-slate-500">{timeAgo(m.created_at)}</span>
          </div>
          <p className="mt-1 text-xs text-slate-400">{m.name} · {m.email}</p>
          <p className="mt-3 whitespace-pre-wrap text-sm text-slate-200">{m.message}</p>
          <div className="mt-4 flex gap-2">
            <a href={`mailto:${m.email}?subject=${encodeURIComponent(`Re: ${m.subject}`)}`} data-testid={`admin-contact-reply-${m.id}`} className="btn-lime px-4 py-2 text-xs"><Mail className="h-4 w-4" />Reply by email</a>
            {m.status === "new" && <button data-testid={`admin-contact-done-${m.id}`} onClick={() => done(m.id)} className="flex items-center gap-1 rounded-xl border border-white/15 px-4 py-2 text-xs font-semibold hover:bg-white/5"><CheckCircle2 className="h-4 w-4" />Mark done</button>}
          </div>
        </div>
      ))}
    </div>
  );
}
